import api from '../api/menu'

const state = {
  menuItems: {},
  menuName: '',
  error: null
}

const getters = {
  menuItems: state => state.menuItems,
  menuName: state => state.menuName
}

const actions = {
  getRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      api
        .fetchMenu(id)
        .then(response => {
          commit('SET_MENU_ITEMS', response.data)
          commit('SET_MENU_NAME')
          resolve(response.data)
        })
        .catch(error => {
          commit('SET_ERROR', error)
          reject(error)
        })
    })
  }
}

const mutations = {
  SET_MENU_ITEMS(state, menu) {
    state.menuItems = menu
  },
  SET_MENU_NAME(state) {
    state.menuName = state.menuItems[0].menuName
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
